import { CameraModel } from './camera.model';
import { UserModel } from './user.model';

export class AlertModel {
  Id: number;
  Name: string;
  TriggerId: number;
  PeerId?: number;
  AlertType: AlertType;
  Enabled: boolean;

  SiteName?: string;
  TriggerCamera?: CameraModel;
  PeerCamera?: CameraModel;
  Recipients?: UserModel[];
}

export enum AlertType {
  Heat = 1,
  Motion = 2,
}
